import React from "react";
import PropTypes from "prop-types";
import {
  AmountSection,
  Head,
  Image,
  List,
  UnorderList,
  UpgradCard,
  Wrapper,
} from "./upgrade-components";
import Typography from "../../common-components/Typography";
import CustomTooltip from "../../common-components/CustomTooltip";
import { font } from "../../constants/font";
import { STATIC_PATH } from "../../constants/config";
import Action from "../../common-components/Action";
import { formatPriceByLocale, PLAN, SYMBOL } from "../../constants";
import content from "../../constants/content";

const PlanCard = ({
  iconSrc,
  planName,
  titleSubtext,
  width,
  height,
  planContent,
  action,
  onClick,
  isSelected,
  actionBgColor,
  data,
  enterpriseContent,
  monthlyPrice,
  yearlyPrice,
  billingCycle,
  className,
  countryCode
}) => {
  const isTeamPlan = data.plan === PLAN.TEAM;

  return (
    <UpgradCard
      width={width}
      height={height}
      enterprise={data.plan === PLAN.ENTERPRISE}
      isPremium={isTeamPlan}
      isSelected={isSelected}
      onClick={onClick}
      className={className}
    >
      <Wrapper>
        <Head>
          <Image src={`${STATIC_PATH}${iconSrc}`} />
          <Typography
            content={planName}
            font={font.bold_16}
            color={"#313345"}
            padding={"3px 0px"}
            cursor={"pointer"}
            enableTrim={false}
          />
        </Head>
        <Typography
          content={titleSubtext}
          font={font.normalMicro12}
          color={"#7B7E8C"}
          padding={"3px 0px"}
          cursor={"pointer"}
          enableTrim={false}
        />
        {data.plan === PLAN.ENTERPRISE ? (
          <Typography
            content={enterpriseContent}
            font={font.normal_14_23}
            color={"#313345"}
            cursor={"pointer"}
            align={"center"}
            enableTrim={false}
            padding="18px 0px"
          />
        ) : (
          <AmountSection isIN={countryCode === "IN"} symbol={SYMBOL[countryCode] || SYMBOL.default}>
            <Typography
              content={formatPriceByLocale(monthlyPrice) || formatPriceByLocale(yearlyPrice)}
              font={font.largeBold_40}
              padding="3px 0"
              color={"#0D0F0F"}
              cursor={"pointer"}
              enableTrim={false}
            />
            <Typography
              content={billingCycle === 0 ? content.MONTH_USER : content.YEARLY_USER}
              font={font.normal_13_22}
              padding="1px 0"
              color={"#4D5061"}
              cursor={"pointer"}
            />
          </AmountSection>
        )}
      </Wrapper>
      <UnorderList>
        {planContent && planContent.map((item, idx) => {
          const text = typeof item === 'string' ? item : item.text;
          const tooltip = typeof item === 'string' ? null : item.tooltip;
          const tooltipId = tooltip ? `plan-tooltip-${idx}-${data.plan}` : null;

          return (
            // eslint-disable-next-line react/no-array-index-key
            <List key={idx}>
              {tooltip ? (
                <CustomTooltip
                  tooltipId={tooltipId}
                  dataTooltip={tooltip}
                  tooltipPosition="top"
                  font={font.normalMicro_16}
                  nonFormattedMessage={true}
                  offset={8}
                >
                  <span data-tooltip-id={tooltipId} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Typography
                      content={text}
                      color={"#313345"}
                      font={font.normalBase_21}
                      enableTrim={false}
                      cursor={"pointer"}
                    />
                    <img src={`${STATIC_PATH}info-outline.svg`} alt="info" style={{ width: '16px', height: '16px', flexShrink: 0,     position: 'absolute', left: '88px',bottom: '2px'
 }} />
                  </span>
                </CustomTooltip>
              ) : (
                <Typography
                  content={text}
                  color={"#313345"}
                  font={font.normalBase_21}
                  enableTrim={false}
                  cursor={"pointer"}
                />
              )}
            </List>
          );
        })}
      </UnorderList>
      <Action
        text={action}
        background={
          isTeamPlan
            ? "transparent linear-gradient(98deg, #FF781A 0%, #F55322 100%)"
            : actionBgColor
        }
        borderRadius={"8px"}
        font={font.boldBase}
        className={isTeamPlan
          ? "upgradeTeam"
          : "upgradeButton"}
      />
    </UpgradCard>
  );
};

PlanCard.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  iconSrc: PropTypes.string,
  titleSubtext: PropTypes.string,
  planName: PropTypes.string,
  planContent: PropTypes.string,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool,
  action: PropTypes.string,
  actionBgColor: PropTypes.string,
  enterpriseContent: PropTypes.string,
  data: PropTypes.object,
  monthlyPrice: PropTypes.number,
  yearlyPrice: PropTypes.number,
  billingCycle: PropTypes.number,
  className: PropTypes.string,
  countryCode: PropTypes.string,
};
export default PlanCard;
